export default __webpack_public_path__ + "static/media/Icon awesome-user-alt.92e1dc64.svg";